import React from "react";
import { Navigate } from "react-router-dom";
import { authService } from "../services";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireCompanyAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
}) => {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
